// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-main[data-v-d5acd0a2]{padding:0}.fb[data-v-d5acd0a2]{padding:35px 40px;height:100%}.fb .reasons[data-v-d5acd0a2]{margin-bottom:30px;text-align:left}.fb .reasons .radio-group[data-v-d5acd0a2]{margin:0}.fb .submit-btn[data-v-d5acd0a2]{width:200px;margin-top:20px}.fb .text-area[data-v-d5acd0a2]{width:500px;margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
